import { Reveal } from "@/components/Reveal";
import { ArrowRight, Flame } from "lucide-react";

const FIYA_IMG = "/assets/fiya-red.png";

export const Roster = () => (
  <section id="roster" data-testid="roster-section" className="py-28 md:py-44 bg-[#FDFBF7] overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal className="mb-16 md:mb-24">
        <h2 className="font-serif-display font-bold tracking-tighter text-4xl md:text-6xl leading-tight">
          The <span className="italic text-[#FF8E9E]">roster.</span>
        </h2>
      </Reveal>

      <div className="grid lg:grid-cols-2 gap-14 lg:gap-24 items-center">
        <Reveal className="relative">
          <div className="absolute -top-10 -left-10 w-40 h-40 rounded-full bg-[#FF8E9E]/50" />
          <div
            data-testid="artist-card-fiya-red"
            className="group relative arch-clip overflow-hidden aspect-[3/4] max-w-md mx-auto shadow-[0_50px_100px_-30px_rgba(45,26,19,0.4)]"
          >
            <img
              src={FIYA_IMG}
              alt="Fiya Red portrait"
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#FF8E9E]/40 via-transparent to-transparent mix-blend-multiply" />
          </div>
          <span className="absolute -bottom-4 left-1/2 -translate-x-1/2 rounded-full bg-[#2D1A13] text-[#FDFBF7] px-6 py-2.5 text-[10px] font-semibold uppercase tracking-[0.25em] whitespace-nowrap">
            On the roster
          </span>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-10 rounded-full bg-[#FF8E9E] text-[#2D1A13] flex items-center justify-center">
              <Flame size={18} strokeWidth={1.8} />
            </span>
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#DDA77B]">
              Hand-picked, never crowded
            </span>
          </div>
          <h3
            data-testid="artist-name-fiya-red"
            className="font-serif-display font-black tracking-tighter text-6xl md:text-8xl leading-[0.95] mb-8"
          >
            Fiya <span className="italic text-[#FF8E9E]">Red</span>
          </h3>
          <p className="text-base md:text-lg font-light leading-relaxed text-[#2D1A13]/75 max-w-lg mb-10">
            Fiya Red leads the Ice Cream Social roster — the first of a hand-picked lineup. Every artist we
            sign gets the whole studio: identity, art direction and a rollout built to burn slow and bright.
          </p>
          <div className="flex flex-wrap gap-3 mb-12">
            {["Brand Identity", "Art Direction", "Rollout Strategy"].map((t) => (
              <span
                key={t}
                className="rounded-full border border-[#2D1A13]/25 px-5 py-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#2D1A13]/70"
              >
                {t}
              </span>
            ))}
          </div>
          <button
            data-testid="roster-cta-button"
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            className="group rounded-full bg-[#2D1A13] text-[#FDFBF7] text-xs font-semibold uppercase tracking-[0.18em] px-9 py-5 flex items-center gap-3 hover:bg-[#FF8E9E] hover:text-[#2D1A13] transition-colors duration-300 w-fit"
          >
            Work with the studio
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);
